import { CSSProperties, memo } from 'react';
import { RequiredSign } from '../RequiredSign';
import { Error, Label } from 'components/common';
import { InputProps } from 'antd';
import { InputPasswordStyled, InputPasswordWrapper } from './styles';

interface IInputProps extends InputProps {
  placeholder?: string;
  defaultValue?: string;
  label?: string | JSX.Element;
  name?: string;
  value?: string | number;
  width?: string;
  height?: string;
  disabled?: boolean;
  isRequired?: boolean;
  autocomplete?: boolean;
  bordered?: boolean;
  style?: CSSProperties;
  error?: string;
  id?: string;
  className?: string;
  maxLength?: number;
}

export const InputPassword = memo(
  ({
    placeholder,
    defaultValue,
    label,
    name,
    onChange,
    value,
    width,
    height,
    error,
    disabled,
    style,
    id,
    maxLength,
    className,
    isRequired,
    onFocus,
    onBlur,
    onKeyDown,
    bordered,
  }: IInputProps) => (
    <InputPasswordWrapper style={{ ...style, width }}>
      {label && (
        <Label>
          {label}
          {isRequired && <RequiredSign> *</RequiredSign>}
        </Label>
      )}
      <InputPasswordStyled
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        {...{
          defaultValue,
          placeholder,
          bordered,
          name,
          maxLength,
          id: id || name,
          onChange,
          value,
          width,
          height,
          error,
          disabled,
          autoComplete: 'off',
          className,
        }}
      />
      {error && <Error>{error}</Error>}
    </InputPasswordWrapper>
  )
);
